const underlineParser = (text: string) => ({
  beginText: text?.split('{')[0] || '',
  endText: text?.split('}')[1] || '',
  underlineText: text?.substring(text?.lastIndexOf('{') + 1, text?.lastIndexOf('}')) || '',
});

export default underlineParser;
